import React from 'react'
import useFetchTableData from '../../hooks/useFetchTableData';
import adminApi from '../../api/admin';
import StatusBadge from '../../components/common/StatusBadge';
import { formatDateForDisplay } from '../../utils/helpers';
import DataTable from '../../components/common/DataTable';
import { Link } from 'react-router-dom';

const AdminJobApplicationPage = () => {
    const {
        data,
        isLoading,
        isError,
        error,
        paginationModel,
        setPaginationModel,
      } = useFetchTableData({
        queryKey: "job-applications",
        fetchFunc: adminApi.getJobApplications,
        // params: filters,
      });

      const columns = [
          {
            field: "job_title",
            headerName: "Job Title",
            flex: 2,
            minWidth: 200,
            renderCell: (params) => (
              <Link
                to={`${params.row.id}`}
                className="text-blue-600 hover:underline"
              >
                {params.value}
              </Link>
            ),
          },
          {
            field: "applicant_name",
            headerName: "Applicant Name",
            flex: 1,
            minWidth: 150,
          },
          {
            field: "company_name",
            headerName: "Company Name",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => params.value || "N/A",
          },
          
          {
            field: "status",
            headerName: "Status",
            flex: 1,
            minWidth: 120,
            renderCell: (params) => (
              <StatusBadge status={params.value} />
            ),
          },
          {
            field: "created_at",
            headerName: "Application Date",
            flex: 1,
            minWidth: 120,
            type: "date",
            valueGetter: (params) => (params ? new Date(params) : null),
            renderCell: (params) => {
              return params.row.created_at
                ? formatDateForDisplay(params.row.created_at)
                : "";
            },
          },
          // {
          //   field: "actions",
          //   type: "actions",
          //   headerName: "Actions",
          //   flex: 1,
          //   minWidth: 150,
          //   getActions: (params) => [
          //     <GridActionsCellItem
          //       icon={<Eye className="w-4 h-4" />}
          //       label="View"
          //       onClick={() => handleView(params.row)}
          //       showInMenu
          //     />,
          //     <GridActionsCellItem
          //       icon={<Edit className="w-4 h-4" />}
          //       label="Edit"
          //       onClick={() => handleEdit(params.row)}
          //       showInMenu
          //     />,
          //     <GridActionsCellItem
          //       icon={<Delete className="w-4 h-4" />}
          //       label="Delete"
          //       onClick={() => handleDelete(params.row)}
          //       showInMenu
          //       sx={{ color: "error.main" }}
          //     />,
          //   ],
          // },
        ];
  if (isError) {
      return (
        <div className="max-w-7xl mx-auto py-8 px-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-red-800">Error loading applications: {error?.message}</p>
          </div>
        </div>
      );
    }
  
    return (
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-secondary-900">
              Job Application Management
            </h1>
            <p className="text-secondary-600 mt-1">
              Total: {data?.count || 0} applications
            </p>
          </div>
          {/* <Button 
            onClick={() => onNavigate('/post-job')} 
            icon={<Plus className="w-4 h-4 mr-2" />}
          >
            Post New Job
          </Button> */}
        </div>
  
        <DataTable
          rows={data?.results}
          columns={columns}
          loading={isLoading}
          rowCount={data?.count}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </div>
    );
}

export default AdminJobApplicationPage